export default __webpack_public_path__ + "static/media/piano-miroir.6cbad2e0.webp";